export const meterTagConfig = {
  NO: {
    bgColor: "bg-chart-red-faint",
    gradient: "from-red-base/25 to-red-base/0",
    icon: "icon-x",
  },
  POSSIBLY: {
    bgColor: "bg-chart-yellow-faint",
    gradient: "from-yellow-base/25 to-yellow-base/0",
    icon: "icon-minus",
  },
  YES: {
    bgColor: "bg-chart-green-faint",
    gradient: "from-green-base/25 to-green-base/0",
    icon: "icon-check",
  },
  MIXED: {
    bgColor: "bg-chart-orange-faint",
    gradient: "from-orange-base/25 to-orange-base/0",
    icon: "icon-asterisk",
  },
  UNKNOWN: {
    bgColor: "bg-bg-faint",
    gradient: "from-subtle to-subtle/0",
    icon: "icon-dashed-line",
  },
};
